import React, { useState } from 'react';
import "./qualification.css";

// Graduation photos live in the public/ folder (served from the site root).
// NOTE: filenames are case-sensitive on the server — these must match exactly.
const BC_GRAD = '/spinoza-delva-brooklyn-college-graduation.jpg';
const ASA_GRAD = '/spinoza-delva-ASA-college-graduation.jpg';

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => setToggleState(index);

    // Real record — edit dates/titles here in one place.
    const education = [
        {
            title: 'B.S. Computer Science',
            org: 'Brooklyn College',
            location: 'Brooklyn, NY',
            date: '2024 - 2026',
            image: BC_GRAD,
            current: true
        },
        {
            title: 'A.O.S. Computer Programming & IT',
            org: 'ASA College (Honors)',
            location: 'New York, NY',
            date: '2018 - 2020',
            image: ASA_GRAD
        }
    ];

    const experience = [
        {
            title: 'Founder & Full-Stack Developer',
            org: 'SpinoSoftBits',
            location: 'Brooklyn, NY',
            date: '2018 - Present',
            current: true
        },
        {
            title: 'Software Developer',
            org: 'Mioym Properties',
            location: 'Westchester, NY',
            date: '2022 - 2024'
        },
        {
            title: 'Software Developer',
            org: 'Automotion Parking Systems',
            location: 'Garden City, NY',
            date: '2020 - 2021'
        },
        {
            title: 'IT Administrator',
            org: 'Vox Media / New York Magazine',
            location: 'New York, NY',
            date: '2020'
        },
        {
            title: 'Programming Intern',
            org: 'Harlem Mothers S.A.V.E.',
            location: 'New York, NY',
            date: '2020'
        }
    ];

    const renderCard = (item) => (
        <div className={`qualification__card ${item.current ? 'qualification__card--current' : ''}`}>
            {item.current && <span className="qualification__badge">Present</span>}
            {item.image && (
                <img
                    src={item.image}
                    alt={`Spinoza Delva — ${item.title}, ${item.org}`}
                    className="qualification__photo"
                    loading="lazy"
                />
            )}
            <h3 className="qualification__title">{item.title}</h3>
            <span className="qualification__subtitle">{item.org}</span>
            <span className="qualification__subtitle qualification__location">{item.location}</span>
            <div className="qualification__calendar">
                <i className="uil uil-calendar-alt"></i>
                {item.date}
            </div>
        </div>
    );

    const renderConnector = (item) => (
        <div>
            <span className={`qualification__rounder ${item.current ? 'qualification__rounder--current' : ''}`}></span>
            <span className="qualification__line"></span>
        </div>
    );

    // Alternates card left / right down the timeline, matching the original layout.
    const renderTimeline = (items) =>
        items.map((item, index) => (
            <div className="qualification__data" key={index}>
                {index % 2 === 0 ? (
                    <>
                        {renderCard(item)}
                        {renderConnector(item)}
                    </>
                ) : (
                    <>
                        <div></div>
                        {renderConnector(item)}
                        {renderCard(item)}
                    </>
                )}
            </div>
        ));

    return (
        <section className="qualification section">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>

            <div className="qualification__container container">
                <div className="qualification__tabs">
                    <div className={toggleState === 1 ? "qualification__button qualification__active button--flex"
                        : "qualification__button button--flex"}
                        onClick={() => toggleTab(1)}
                    >
                        <i className="uil uil-graduation-cap qualification__icon"></i>
                        Education
                    </div>

                    <div className={toggleState === 2 ? "qualification__button qualification__active button--flex"
                        : "qualification__button button--flex"}
                        onClick={() => toggleTab(2)}
                    >
                        <i className="uil uil-briefcase-alt qualification__icon"></i>
                        Experience
                    </div>
                </div>

                <div className="qualification__sections">
                    <div className={toggleState === 1 ? "qualification__content qualification__content-active"
                        : "qualification__content"}
                    >
                        {renderTimeline(education)}
                    </div>

                    <div className={toggleState === 2 ? "qualification__content qualification__content-active"
                        : "qualification__content"}
                    >
                        {renderTimeline(experience)}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Qualification;